import React from "react"
import { OutboundLink } from "gatsby-plugin-google-gtag"

import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Image from "react-bootstrap/Image"
import Button from "react-bootstrap/Button"

import starImage from "../images/stars5_0.png"

const setMonth = () => {
  const today = new Date()

  const month = today.toLocaleString("default", { month: "long" })

  return month
}

const Highlighted = props => {
  const {
    img,
    alt,
    highlight,
    nonHighlight,
    line2,
    deposit,
    play,
    score,
    redirect,
  } = props.casino

  const wallId = "ccdReg"
  if (props.params !== undefined) {
    var { s1, s2, s3, s4, s5, iid, page_id, affid } = props.params
  }
  return (
    <Row className="casino__row hgh__row">
      <div class="highlighted-row-image"></div>

      <Col xs={12}>
        <div class="row">
            <Col sm={12} md={3} className="hgh-left">
                <div className="casino__container--img">
                  <OutboundLink
                    href={
                      props.params !== undefined
                        ? `${redirect}&s1=${s1}&s2=${page_id}&s3=${wallId}&s4=${s1}_${s2}_${s3}_${s4}_${s5}&s5=${iid}`
                        : `${redirect}`
                    }
                  >
                    <Image src={img} alt={alt} />
                  </OutboundLink>
                </div>
            </Col>
            <Col sm={12} md={9} className="casino__col">
              <Col xs={12} className="highlighted__header">
                 <h1>{setMonth()} Offer of the Month</h1>
              </Col>
              <div className="casino__container--promo">
                <h4 className="promo">
                  <span className="promo__line-1">
                    <span className="promo__line-1--highlight">{highlight}</span>{" "}
                    {nonHighlight}
                  </span>
                  <span className="promo__line-2">{line2}</span>
                </h4>
                <p>*T/C Apply</p>
              </div>
              <div className="casino__container--deposit">
                <h4>Deposit</h4>
                <p>{deposit}</p>
              </div>
              <div className="casino__container--play">
                <h4>Play With</h4>
                <p>{play}</p>
              </div>
              <div className="casino__container--rating">
                <h4>our score: {score}</h4>
                <img src={starImage} alt="stars" />
              </div>
              <div className="casino__container--btn">
                <OutboundLink
                  href={
                    props.params !== undefined
                      ? `${redirect}&s1=${s1}&s2=${page_id}&s3=${wallId}&s4=${s1}_${s2}_${s3}_${s4}_${s5}&s5=${iid}`
                      : `${redirect}`
                  }
                >
                  <Button className="btn-xl highlight__btn">Play Now</Button>
                </OutboundLink>
              </div>
            </Col>
        </div>
      </Col>
    </Row>
  )
}

export default Highlighted
